export default __webpack_public_path__ + "static/media/courses-active.fdddff35.svg";